import { Skeleton } from 'antd';
import styled from 'styled-components';

export const Container = styled.div({
  display: 'inline-block',
});

export const Image = styled.img({
  width: '100%',
  height: '100%',

  '&.image--hidden': {
    display: 'none',
  },
});

export const SkeletonImage = styled(Skeleton.Image)({
  // AntD Override
  width: '100% !important',
  height: '100% !important',
});
